let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("a9qyt")).then(() => parcelRequire('6xDrT'));